var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOmniChannel01 = function SvgOmniChannel01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "omni_channel-01_svg2__a",
    x1: 21.4,
    x2: 153.87,
    y1: 143.88,
    y2: 11.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__b",
    x1: 1.41,
    x2: 133.88,
    y1: 123.88,
    y2: -8.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__c",
    x1: 25.43,
    x2: 157.9,
    y1: 147.91,
    y2: 15.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__d",
    x1: 7.1,
    x2: 139.57,
    y1: 129.57,
    y2: -2.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__e",
    x1: 0.43,
    x2: 132.9,
    y1: 122.9,
    y2: -9.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__f",
    x1: 8.76,
    x2: 141.23,
    y1: 131.24,
    y2: -1.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__g",
    x1: 71.41,
    x2: 203.88,
    y1: 193.88,
    y2: 61.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__h",
    x1: 63.76,
    x2: 196.24,
    y1: 186.24,
    y2: 53.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__i",
    x1: 53.76,
    x2: 186.23,
    y1: 176.24,
    y2: 43.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__j",
    x1: 82.09,
    x2: 214.57,
    y1: 204.57,
    y2: 72.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__k",
    x1: 73.76,
    x2: 206.23,
    y1: 196.24,
    y2: 63.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_channel-01_svg2__a",
    id: "omni_channel-01_svg2__l",
    x1: 55.43,
    x2: 187.9,
    y1: 177.91,
    y2: 45.43
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 33.33c1.84 0 3.33-1.49 3.33-3.33V10c0-1.83 1.5-3.33 3.33-3.33h80c1.83 0 3.33 1.5 3.33 3.33v40c0 1.83-1.5 3.33-3.33 3.33h-6.67c-1.84 0-3.33 1.49-3.33 3.33v10.79l-10.77-12.93c-.63-.77-1.57-1.2-2.56-1.2h-10c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h8.44l15.67 18.8a3.32 3.32 0 0 0 3.69 1c1.32-.48 2.2-1.73 2.2-3.13V59.98h3.33c5.51 0 10-4.49 10-10V10C180 4.49 175.51 0 170 0H90c-5.51 0-10 4.49-10 10v20c0 1.84 1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 113.35v-.02h-6.67c-1.05 0-2.04.49-2.67 1.33l-14 18.67v-16.67c0-1.84-1.49-3.33-3.33-3.33H10c-1.83 0-3.33-1.5-3.33-3.33V50c0-1.83 1.5-3.33 3.33-3.33h106.67c1.83 0 3.33 1.5 3.33 3.33v26.67c0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33V50c0-5.51-4.49-10-10-10H10C4.49 40 0 44.49 0 50v60c0 5.51 4.49 10 10 10h10v23.33c0 1.43.92 2.71 2.28 3.17.35.11.7.17 1.05.17 1.03 0 2.03-.47 2.67-1.33l19-25.33h5c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 30c0-1.84-1.49-3.33-3.33-3.33H130c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.67 26.67c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33z",
    style: {
      fill: "url(#omni_channel-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 86.67C21.49 86.67 20 88.16 20 90s1.49 3.33 3.33 3.33h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33z",
    style: {
      fill: "url(#omni_channel-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66 76.67c0-1.84-1.49-3.33-3.33-3.33h-80c-1.84 0-3.33 1.49-3.33 3.33S21.49 80 23.33 80h80c1.84 0 3.33-1.49 3.33-3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 86.66H70c-5.51 0-10 4.49-10 10v66.67c0 5.51 4.49 10 10 10h85l19 25.33a3.32 3.32 0 0 0 2.67 1.33c.35 0 .71-.06 1.05-.17a3.35 3.35 0 0 0 2.28-3.17v-23.33h10c5.51 0 10-4.49 10-10V96.65c0-5.51-4.49-10-10-10Zm3.33 76.67c0 1.83-1.5 3.33-3.33 3.33h-13.33c-1.84 0-3.33 1.49-3.33 3.33v16.67l-14-18.67a3.33 3.33 0 0 0-2.67-1.33H70c-1.83 0-3.33-1.5-3.33-3.33V96.66c0-1.83 1.5-3.33 3.33-3.33h120c1.83 0 3.33 1.5 3.33 3.33z",
    style: {
      fill: "url(#omni_channel-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67 146.67H83.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 140h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-20c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67 120H150c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 133.33h-33.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33H150c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 126.67h53.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H83.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#omni_channel-01_svg2__l)"
    }
  }));
};
export default SvgOmniChannel01;